import { useRef } from 'react';

export const useLocalState = ( state: any ) =>
{
    const state_ = useRef( state );
	return state_.current;
};
